import { Link } from 'react-router-dom';

export function Footer(): React.JSX.Element {
  return (
    <footer className="marketing-footer">
      <div className="marketing-container marketing-footer-grid">
        <div className="flex items-center gap-2">
          <img src="/revont-logo.svg" alt="" className="h-5 w-5" />
          <span>Revont LLC</span>
        </div>
        <nav className="marketing-footer-links" aria-label="Footer">
          <Link to="/product">Product</Link>
          <Link to="/mission">Mission</Link>
          <a href="https://docs.revont.ai" target="_blank" rel="noreferrer">
            User Guide ↗
          </a>
          <Link to="/pricing">Pricing</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Talk to Us</Link>
        </nav>
        <span>© 2026 Revont LLC</span>
      </div>
    </footer>
  );
}
